'use client';
import react from "react";
import { createAuthClient, idTokenPayloadKeys } from "@nestle-npus-nbm/purina-auth";
import swr from "swr";
const useGetAuth0User = (config)=>{
    const Auth = react.useMemo(()=>createAuthClient(config.auth0), [
        config.auth0
    ]);
    const fetcher = ()=>Auth.getSession();
    let cacheKey = '';
    const params = new URLSearchParams(window.location.search);
    if (!params.get('code')) cacheKey = 'GetAuth0User';
    const { data, error, isLoading, mutate } = swr(cacheKey, fetcher, {
        revalidateOnFocus: false,
        revalidateIfStale: false,
        dedupingInterval: 3000,
        errorRetryCount: 2,
        shouldRetryOnError: (err)=>'login_required' !== err.code
    });
    return {
        ansiraId: data?.idTokenAttributes?.[idTokenPayloadKeys.ansiraId],
        ansiraUuid: data?.idTokenAttributes?.[idTokenPayloadKeys.ansiraUuid],
        attributes: data?.idTokenAttributes,
        accessToken: data?.accessToken,
        idToken: data?.idToken,
        error,
        isLoading,
        mutate
    };
};
export { useGetAuth0User };
